import { render, staticRenderFns } from "./InventoryMonitoring.vue?vue&type=template&id=902cc744"
import script from "./InventoryMonitoring.vue?vue&type=script&lang=js"
export * from "./InventoryMonitoring.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports